import React from 'react';

const Food = () => (
  <>
    <h1>Food</h1>

    <p>
      Lorem ipsum dolor sit amet, <i>consectetur</i> adipiscing elit, sed do
      eiusmod tempor incididunt ut labore et dolore magna aliqua. Ultrices vitae
      auctor eu augue ut lectus arcu bibendum. Enim praesent elementum facilisis
      leo. Vitae nunc sed velit dignissim sodales. Vulputate mi sit amet mauris
      commodo quis. Maecenas accumsan lacus vel facilisis volutpat est. Ut sem
      nulla pharetra diam sit amet nisl suscipit adipiscing. Eget egestas purus
      viverra accumsan. Quis auctor elit sed vulputate mi sit amet. Urna cursus
      eget nunc scelerisque viverra mauris. Volutpat consequat mauris nunc
      congue nisi vitae suscipit tellus. At imperdiet dui accumsan sit amet.
      Blandit massa enim nec dui nunc. Purus sit amet volutpat consequat.
      Egestas erat imperdiet sed euismod nisi porta lorem mollis. Nulla facilisi
      etiam dignissim diam quis enim lobortis scelerisque fermentum.
    </p>

    <p>
      Eu augue ut lectus arcu bibendum at varius. Sem fringilla ut morbi
      tincidunt augue. Amet massa vitae tortor condimentum lacinia. Sapien eget
      mi proin sed libero enim sed faucibus. Tellus orci ac auctor augue mauris
      augue neque gravida in. Tellus at urna condimentum mattis pellentesque id
      nibh. Vitae congue mauris rhoncus aenean vel elit scelerisque mauris
      pellentesque. Mattis ullamcorper velit sed ullamcorper morbi tincidunt
      ornare massa. Etiam non quam lacus suspendisse. Pellentesque habitant
      morbi tristique senectus et netus et malesuada fames. Facilisi cras
      fermentum odio eu.
    </p>
  </>
);

export default Food;
